import {AbstractControl, FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup} from "@angular/forms";

export default class FormUtils {

  /**
   * Highlight all invalid form controls for a specific form group.
   * The form control are highlighted by marking each control as touched.
   *
   * @param form UntypedFormGroup for which all invalid form controls should be highlighted
   */
  public static markInvalidInputs(form: UntypedFormGroup): void {
    Object.keys(form.controls).forEach(key => {
      if (form.get(key) instanceof UntypedFormControl) {
        form.get(key)?.markAsTouched()
      }
      if (form.get(key) instanceof UntypedFormArray) {
        form.get(key)?.markAllAsTouched()
      }
      if (form.get(key) instanceof FormGroup) {
        form.get(key)?.markAllAsTouched()
      }
    })
  }

  /**
   * Determines if a specific control of a form is valid after it was touched
   *
   * @param control AbstractControl that should be checked
   * @return true if the control is invalid and was touched else false
   */
  public static hasError(control: AbstractControl): boolean {
    return (control.invalid && control.touched);
  }
}
